// --------------------------------------------------------------
// Created On: 2021-09-21
// Author: Zachary Thomas
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import { Modal } from "react-bootstrap";

// Generic modal header.
export default function ModalHeader(props: Props): Component {
  return (
    <Modal.Header data-test="modal-header" className={props.className || undefined}>
      {props.children}
    </Modal.Header>
  );
}

interface Props {
  className?: string;
  children?: React.ReactNode;
}
